import React, { useState } from "react";
import axios from "../../../library/axios";
import { MySwal } from "../../../library/swal";
import Button from "react-bootstrap/Button";
import { useParams } from "react-router";
import { IconDeviceFloppy, IconSquareX } from "@tabler/icons-react";
import { getSlug, } from "../../../../src/config/routes/guards/slug";
import {
  MAX_UPLOAD_MB,
  DOCUMENT_MIME_TYPES,
  DOCUMENT_MIME_LABEL,
  validateUploadFile,
} from "../../../constants/upload";
import { getApiErrorMessage } from "../../../helpers/apiErrorMessage";

const CreatePpsDokumenComp = (props) => {
  const url = new URL(window.location.href);

  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const [namaDokumen, setnamaDokumen] = useState("");
  // const [dokumen, setDokumen] = useState('');
  const [base64String, setBase64String] = useState("");
  // const [mimeType, setMimeType] = useState('');
  const [originalName, setOriginalName] = useState("");
  // const [syncSpeakOnline, setsyncSpeakOnline] = useState("Tidak");

  const routeParams = useParams();

  const handleImageChange = (e) => {
    const selectedFile = e.target.files && e.target.files[0];

    // User membatalkan dialog pilih file.
    if (!selectedFile) {
      setBase64String("");
      setOriginalName("");
      setDisabled(false);
      return;
    }

    const invalid = validateUploadFile(selectedFile, {
      allowedMimeTypes: DOCUMENT_MIME_TYPES,
      allowedLabel: DOCUMENT_MIME_LABEL,
    });
    if (invalid) {
      MySwal.fire({ icon: "error", title: invalid.title, text: invalid.text });
      e.target.value = "";
      setBase64String("");
      setOriginalName("");
      setDisabled(true);
      return;
    }

    setDisabled(false);
    setOriginalName(selectedFile.name);

    const reader = new FileReader();
    reader.onloadend = () => {
      setBase64String(reader.result);
    };
    reader.onerror = () => {
      setBase64String("");
      setOriginalName("");
      setDisabled(true);
      MySwal.fire({
        icon: "error",
        title: "Gagal Membaca File",
        text: "File tidak dapat dibaca dari perangkat Anda. Silakan pilih ulang file-nya.",
      });
    };
    reader.readAsDataURL(selectedFile);
  };

  const handleCreate = () => {
    if (!base64String) {
      MySwal.fire({
        icon: "warning",
        title: "Dokumen Belum Dipilih",
        text: "Silakan pilih file dokumen (PDF atau Excel) terlebih dahulu sebelum menyimpan.",
      });
      return;
    }

    setLoading(true);
    setDisabled(true);

    const requestBody = {
      baseUrl: url.origin,
      idItemPps: routeParams.id,
      syncSpeakOnline: "Tidak",
      nama_dokumen: namaDokumen || originalName,
      dokumen: base64String,
    };
    // console.log(requestBody);
    // return false;
    axios({
      url: "/pps-item/upload-dokumen-pps",
      method: "POST",
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then(() => {
        MySwal.fire({
          icon: "success",
          title: "Success",
          text: "Successfully tambah dokumen!",
        });

        props.close();
        props.fetch();
      })
      .catch((err) => {
        console.error("[upload-dokumen-pps] gagal:", err?.response?.status, err?.response?.data || err?.message);

        // Sesi habis / akses ditolak sudah ditangani oleh interceptor axios.
        if (err?.isHandledByInterceptor) return;

        MySwal.fire({
          icon: "error",
          title: "Dokumen Gagal Disimpan",
          text: getApiErrorMessage(
            err,
            "Dokumen gagal disimpan. Silakan coba lagi, dan hubungi administrator bila tetap gagal."
          ),
        });
      })
      .finally(() => {
        setLoading(false);
        setDisabled(false);
      });
  };

  return (
    <>
      <div className="mb-3 row">
        <label htmlFor="dokumen" className="col-sm-12 col-form-label required">
          Upload Dokumen
        </label>
        <div className="col-12 mb-1">
          <input
            type="file"
            onChange={handleImageChange}
            className="form-control"
            id="dokumen"
          />
        </div>
        <span>
          <i className="text-info required">
            Dokumen harus dalam bentuk PDF atau Excel, maksimal {MAX_UPLOAD_MB} MB
          </i>
        </span>
      </div>
      <div className="mb-3 row">
        <label htmlFor="namaFile" className="col-sm-12 col-form-label">
          Nama Dokumen
        </label>
        <div className="col-12">
          <input
            type="text"
            onChange={(e) => setnamaDokumen(e.target.value)}
            className="form-control"
            id="namaFile"
            autoComplete="off"
          />
        </div>
      </div>
      {/* <div className="mb-3 row">
        <label htmlFor="syncSpeakOnline" className="col-sm-12 col-form-label">
          Sync SPEAK Online
        </label>
        <div className="col-12">
          <select
            className="form-control"
            id="syncSpeakOnline"
            name="syncSpeakOnline"
            onChange={(e) => setsyncSpeakOnline(e.target.value)}
            value={syncSpeakOnline}
          >
            <option value="Tidak">Tidak</option>
            <option value="Ya">Ya</option>
          </select>
          {syncSpeakOnline === "Tidak" ? (
            <small className="text-info">
              Dokumen tidak akan di sinkron ke SPEAK Online.
            </small>
          ) : (
            <small className="text-info">
              Dokumen akan langsung di sinkron ke SPEAK Online.
            </small>
          )}
        </div>
      </div> */}

      <div className="mt-5 row">
        <div className="d-flex flex-center flex-row-fluid pt-2">
          <Button
            disabled={disabled}
            variant="primary"
            size="sm"
            onClick={() => handleCreate()}
          >
            <IconDeviceFloppy stroke={2} />{" "}
            {loading === true ? "Mohon Tunggu.." : "Simpan"}
          </Button>
          &nbsp;
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            <IconSquareX stroke={2} /> Tutup
          </Button>
        </div>
      </div>
    </>
  );
};

export default CreatePpsDokumenComp;
